import React, { useEffect, useState } from "react";
import { Card, Grid, Typography, Avatar, Box, Button } from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import EventIcon from "@mui/icons-material/Event";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EmailIcon from "@mui/icons-material/Email";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";

export default function CandidateNotifications() {
  const Navigate = useNavigate();

  const {
    candidateData,
    candidateJobData,
    triggerSomethingFromLayout,
    notifications,
  } = useCandidateLayout();

  const handleRead = async (item) => {
    try {
      const res = await axiosAPI.post(`Notification/updateStatus`, {
        isRead: 1,
        NotificationId: item?.NM_Id,
      });
      if (res?.data?.success) {
        triggerSomethingFromLayout();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box sx={{ p: 2, mx: "auto" }}>
      <Typography
         sx={{
                fontFamily: "Geist, sans-serif",
                letterSpacing: `0.5px`,
                fontSize: "24px",
                color: "#333",
                fontWeight: "600",
              }}
              mb={2}
      >
        Notifications
      </Typography>
      <Grid container spacing={3}>
        {Array.isArray(notifications) && notifications.length > 0 ? (
          notifications
            ?.slice() // to avoid mutating original array
            ?.sort((a, b) => a.NM_isRead - b.NM_isRead)
            ?.map((item) => (
              <Grid item xs={12} key={item?.NM_Id}>
                <Card
                  onClick={() => handleRead(item)}
                  sx={{
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    opacity: item?.NM_isRead ? 0.5 : 1,
                    transition: "opacity 0.3s",
                  }}
                >
                  <Avatar
                    sx={{ bgcolor: item?.NM_isRead ? "grey" : "#006CB8" }}
                  >
                    {/* {icon} */}
                  </Avatar>
                  <Box>
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ fontFamily: "Geist, sans-serif" }}
                    >
                      {item.NM_Message}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontFamily: "Geist, sans-serif" }}
                    >
                      {item?.NM_CreatedDate}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))
        ) : (
          <Grid item xs={12}>
            <Typography

              align="center"
              sx={{ fontFamily: "Geist, sans-serif", mt: 2, fontSize:"22px" }}
            >
              No notifications to show.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
